module.exports = __webpack_public_path__ + "img/nx.6e99e410.png";